module.exports = __webpack_public_path__ + "5268d2bec3c39356768b254975a92cc8.jpg";